const custMenu = {
	ZZ: {
		shortName: ['外掛', 'plug-in.', '外挂'],
		name: ['外掛', 'plug-in', '外挂'],
		ico: 'suitcase',
		hint: [],
		children: {
			ZZ1: {
				name: ['出勤', 'Attendance hours', '出勤'],
				children: {					
					ZZ_STARLIKE_AM10621: {
						name: ['(客製)部門標籤設定', '(客製)部門標籤設定', '(客製)部门标籤设定'],
						url: '/zz_starlike_am10621',
						hint: [],
					},
					ZZ_STARLIKE_AM10622: {
						name: ['(客製)跨店支援時數報表', '(客製)跨店支援時數報表', '(客製)跨店支援时数报表'],
						url: '/zz_starlike_am10622',
						hint: [],
					},
				},
			},
		},
	},
};

module.exports = (paidMenu) => {
	return { ...paidMenu, ...custMenu };
	
};